import { CombinedGraphQLErrors } from '@base-app/web2'
import type { TFunction } from 'i18next'

// The `extensions.reason` values the API sets on collaborator function errors
const REASONS = [
  'FUNCTION_NAME_REQUIRED',
  'FUNCTION_NAME_TOO_LONG',
  'FUNCTION_NAME_TAKEN',
  'FUNCTION_LOCKED',
  'FUNCTION_IN_USE',
  'FUNCTION_LIMIT',
  'FUNCTION_NOT_FOUND',
  'FORBIDDEN',
]

// The first known reason an error carries, if any
export function collaboratorFunctionErrorReason(err: Error): string | undefined {
  if (CombinedGraphQLErrors.is(err)) {
    for (const gqlError of err.errors) {
      // FORBIDDEN is an error code (no reason): the API refuses a write the user has no permission for
      const reason = gqlError.extensions?.reason ?? gqlError.extensions?.code
      if (typeof reason === 'string' && REASONS.includes(reason)) {
        return reason
      }
    }
  }
  return undefined
}

// The translated message for a known reason; any other error keeps its own message
export function collaboratorFunctionErrorMessage(err: Error, t: TFunction): string {
  const reason = collaboratorFunctionErrorReason(err)
  return reason ? t(`collaboratorFunctions.errors.${reason}`) : err.message
}
